import React, { Component } from 'react';
import { DateRange } from 'react-date-range';

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';

import TextField from '@material-ui/core/TextField/index';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';
import InputLabel from '@material-ui/core/InputLabel';
//import {es} from 'date-fns/locale';
import { es } from 'react-date-range/src/locale/index.js'
import { addDays, addMonths } from 'date-fns';
import Grid from '@material-ui/core/Grid';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import PerfectScrollbar from 'react-perfect-scrollbar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
//import ListItemIcon from '@material-ui/core/ListItemIcon';
//import ListItemText from '@material-ui/core/ListItemText';
import Button from '@material-ui/core/Button';
import Popover from '@material-ui/core/Popover';
import { Typography } from '@material-ui/core';
import { withTranslation } from 'react-i18next';

class WeightedItem extends Component {
    constructor(props) {
        super(props);
        //console.log('item', props)
        this.state = {
            weighted: this.props?.weighted,
            idWeighted: this.props?.idWeighted?.ponderacion_id,
            error: false
        }
    }

    handleFieldChange = (field, value) => {
        const { weighted } = this.state
        var newWeighted = weighted
        newWeighted.map(ele => {
            if (ele.inicio === field) {
                ele.valor = parseInt(value)
            }
        })
        this.setState({
            weighted: newWeighted
        });
        //console.log('change',newWeighted, field, value)
    }


    handleSaved = async (value) => {
        const { weighted } = this.state
        var newWeighted = weighted
        var contValue = 0
        newWeighted.map(ele => {
            contValue += ele.valor
        })
        if (contValue !== 100) {
            this.setState({
                error: true
            });
        } else {
            fetch(`http://172.21.4.15:8082/reporte/online/indicadores/InsertWeighted/?idWeighted=5&token=02f95a34e4d8247bceb2ba957d1a8dfef80d7deb&key=07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E2&listWeighted=${JSON.stringify(weighted)}`)
                .then(response => response.json())
                .then(myJson => {
                })
            this.setState({
                error: false
            });
        }
    }
    render() {

        const { weighted, idWeighted, error } = this.state
        const { t } = this.props;
        console.log(error)
        return (
            <PerfectScrollbar>
                <Portlet style={{ width: "450px" }}
                >
                    <PortletHeader>
                        <PortletLabel
                            //subtitle="Actualizar Contraseña"
                            title="Ponderación Por Hora"
                        />

                    </PortletHeader>
                    <PortletContent>
                        <form autoComplete="off" noValidate>

                            {weighted.map(ele => (
                                <Grid
                                    container direction="row" justify="center" alignItems="flex-end" spacing={1} key={ele.inicio}
                                    style={{ borderBottom: "1px solid #525252" }}
                                >
                                    <Grid
                                        item
                                        sm={3}
                                        xl={3}
                                        xs={3}
                                    >
                                        <Typography variant="caption">{ele.inicio}</Typography>
                                    </Grid>
                                    <Grid
                                        item
                                        sm={3}
                                        xl={3}
                                        xs={3}
                                    >
                                        <Typography variant="caption">{ele.termino}</Typography>
                                    </Grid>
                                    {/*<Grid
                                        item
                                        sm={3}
                                        xl={3}
                                        xs={3}
                                        >
                                        <Grid container direction="row" justify="center" alignItems="center" spacing={1} key={ele.inicio}>
                                            <Grid
                                                item
                                                sm={12}
                                                xl={12}
                                                xs={12}
                                            >
                                                <Typography variant="caption"> %P. Actual</Typography>
                                            </Grid>
                                            <Grid
                                                item
                                                sm={12}
                                                xl={12}
                                                xs={12}
                                            >
                                                <Typography variant="caption">{ele.valor}</Typography>
                                            </Grid>
                                        </Grid>
                                        
                                        
                                    </Grid>*/}
                                    <Grid
                                        item
                                        sm={6}
                                        xl={6}
                                        xs={6}
                                        style={{ textAlign: "center" }}
                                    >
                                        <FormControl style={{ width: "60%" }} >
                                            <InputLabel htmlFor="age-native-helper" variant="h6"> % Ponderación</InputLabel>
                                            <NativeSelect
                                                name="type"
                                                variant="outlined"
                                                style={{ paddingLeft: "70px" }}
                                                value={ele.valor}
                                                onChange={event =>
                                                    this.handleFieldChange(ele.inicio, event.target.value)
                                                }
                                            >
                                                {Array.apply(1, Array(100)).map((x, i) => (
                                                    <option key={i} value={i}>{i}</option>
                                                ))}
                                            </NativeSelect>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            ))}
                        </form>

                    </PortletContent>
                    <PortletFooter >
                        <Grid
                            container direction="row" justify="center" alignItems="flex-end" spacing={1}
                        >
                            <Grid
                                item
                                sm={12}
                                xl={12}
                                xs={12}
                            >
                                {error ?
                                    <Typography varian="h6">{t('helpers.weightedTime.sum')}</Typography>
                                    :
                                    null
                                }
                            </Grid>
                            <Grid
                                item
                                sm={12}
                                xl={12}
                                xs={12}
                            >
                                <Button
                                    color="primary"
                                    variant="contained"
                                    onClick={this.handleSaved}
                                >
                                    <Typography varian="button">{t('helpers.weightedTime.save')}</Typography>
                                </Button>
                            </Grid>
                        </Grid>


                    </PortletFooter>
                </Portlet>
            </PerfectScrollbar>
        )
    }
}

export default withTranslation()(WeightedItem);